<template>

    <v-dialog
      v-model="$store.state.dialogoDireccion"
      max-width="490"
      >

      <h4 class="text-center black white--text">Direccion de Entrega</h4>
      <v-card>
          <v-form
              ref="form"
              class="pa-3"
              v-model="valid"
              lazy-validation
            >
              <v-row class="mt-n5">
              <v-col cols="6" xs="6">
                  <v-select
                v-model="departamento"
                 :rules="depaRules"
                class="mb-3"
                :items="departamentos"
                menu-props="auto"
                hide-details
                label="Departamento"
                ></v-select>
              </v-col>
              <v-col cols="6" xs="6">
              <v-text-field
                v-model="provincia"
                :counter="8"
                :rules="depaRules"
                label="Provincia"
                required
              ></v-text-field>
              </v-col>
              </v-row>

              <v-text-field
                class="mt-n8"
                v-model="distrito"
                :counter="8"
                :rules="depaRules"
                label="Distrito"
                required
              ></v-text-field>

            <v-text-field
             class="mt-n4"
                v-model="direccion"
                :counter="8"
                :rules="depaRules"
                label="Direccion(Urb/Calle/Mz/Lt/Nº)"
                required
              ></v-text-field>
              
            <v-text-field
             class="mt-n4 "
                v-model="referencia"
                :counter="8"
                :rules="depaRules"
                label="Referencia"
                required
              ></v-text-field>


            </v-form>
        
        <v-card-actions>
          <v-btn
          :disabled="!valid"
            color="success"
            class="mr-4"
            @click.stop="agregar"
          >
            Guardar
          </v-btn>

          <v-btn
            color="error"
            text
             @click.stop="$store.commit('abrirdialogodireccion')"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
   
      </v-card>

    </v-dialog>
</template>

<script>
import { db } from '../db'
import store from '@/store/index'
import ubigeo from '@/ubigeo-peru.min.json';

  export default {
    name: 'dialogoDireccion',
        data() {
        return {
        ubigeo,
        direc:[],
        valid: true,
        departamento:'La Libertad',
        provincia:'',
        distrito:'',
        direccion:'',
        referencia:'',
        depaRules: [
        v => !!v || 'is required',
        ],
        departamentos:[
                  'Amazonas',
                  'Áncash',
                  'Apurímac',
                  'Arequipa',
                  'Ayacucho',
                  'Cajamarca',
                  'Cusco',
                  'Huancavelica',
                  'Huánuco',
                  'Ica',
                  'Junín',
                  'La Libertad',
                  'Lambayeque',
                  'Lima',
                  'Loreto',
                  'Moquegua',
                  'Piura',
                  'Puno',
                  'San Martín',
                  'Tacna',
                  'Tumbes',
                  'Ucayali',
        ]
        }
      },
 

       methods: {
        agregar(){
                this.$refs.form.validate()
            if(this.departamento!="" && this.provincia!=""&& this.distrito!=""
            && this.direccion!=""&& this.referencia!=""){
                this.direc = [],
                this.direc.push({
                    departamento:this.departamento,
                    provincia:this.provincia,
                    distrito:this.distrito,
                    direccion:this.direccion,
                    referencia:this.referencia
                }),
                store.commit('ingresaDireccion',this.direc),
                store.commit('abrirdialogodireccion')
                this.SubeClienteBD()
            }
        },
        SubeClienteBD(){
              db.database().ref("cliente").child(store.state.cliente[0].dni).set({
                    dni:store.state.cliente[0].dni,
                    nombreCompleto:store.state.cliente[0].nombreCompleto,
                    celular:store.state.cliente[0].celular,
                    correo:store.state.cliente[0].correo,
                    ruc:store.state.cliente[0].ruc,
                    nacimiento:store.state.cliente[0].nacimiento,
                    departamento:this.departamento,
                    provincia:this.provincia,
                    distrito:this.distrito,
                    direccion:this.direccion,
                    referencia:this.referencia
                    }
              );
        },



        validate () {
            this.$refs.form.validate()
        },

    },



  }
</script>